/**
 * Mail zu einer Phasenaufgabe — „Angebot nachfassen" oder „Zahlungserinnerung"
 * (Plan Projekt-Tracking, Etappe 4). Der Text kommt fest vom Server, gesendet
 * wird im gewohnten Schreibfenster von Hand. Danach steht der Vorgang in der Spur
 * des Belegs und die Aufgabe ist abgehakt.
 */
import { fehlerText } from "@vimaana/ui";

import { usePhasenaufgabeEntwurf, usePhasenaufgabeGesendet } from "../../hooks/usePhasenaufgaben";
import PostSchreiben, { type SchreibZiel } from "../projekt/PostSchreiben";
import "../../styles/post.css";

type Props = { notizId: string; ziele: SchreibZiel[]; onClose: () => void };

export default function PhasenMail({ notizId, ziele, onClose }: Props) {
  const q = usePhasenaufgabeEntwurf(notizId);
  const gesendet = usePhasenaufgabeGesendet();
  const d = q.data;

  if (!d) {
    return (
      <div className="vg-schreib-schleier" onMouseDown={(e) => { if (e.target === e.currentTarget) onClose(); }}>
        <section className="vg-schreib" role="dialog" aria-modal="true" aria-label="Mail vorbereiten">
          <header className="vg-schreib-kopf">
            <div>
              <p className="vg-schreib-ueber">Schreiben</p>
              <h2>Mail vorbereiten</h2>
            </div>
            <button type="button" className="vg-schreib-zu" onClick={onClose} aria-label="Schließen">×</button>
          </header>
          <p className={q.error ? "vg-post-fehler" : "vg-schreib-hinweis"}>{q.error ? fehlerText(q.error) : "Lädt …"}</p>
        </section>
      </div>
    );
  }

  return (
    <PostSchreiben
      onClose={onClose}
      projektId={d.projekt_id || undefined}
      ziele={ziele}
      an={d.an || ziele[0]?.email || ""}
      betreff={d.betreff}
      text={d.text}
      titel={d.titel}
      onGesendet={(erg) => gesendet.mutate({ notizId, an: erg?.an || [] })}
    />
  );
}
